import { useAuth } from "@clerk/clerk-react";
import { LoadingButton } from "@mui/lab";
import {
  Backdrop,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { AdminUserContext } from "contexts/Admin";
import { useContext, useState } from "react";

import Alert from "components/Alert";
import Loading from "components/Loading";
import StyledPage from "components/Styled/Page";
import { fetcherAuth } from "utils/api";
import { useAlert } from "utils/useAlert";

import styles from "./styles";

const InstagramPage = () => {
  const { getToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, severity, setAlert, closeAlert] = useAlert();

  const context = useContext(AdminUserContext);
  const { currentAdminUser } = { ...context };

  const saveFacebookAccount = async (authResponse: any) => {
    try {
      const requestBody = {
        facebookUserId: authResponse.userID,
        facebookAccessToken: authResponse.accessToken,
      };

      const response = await fetcherAuth(
        getToken,
        "/api/admin/facebook-accounts",
        "POST",
        {},
        requestBody,
      );

      setAlert(
        response.message || "Facebook account saved successfully!",
        "success",
      );
    } catch (error: any) {
      console.error("Error saving Facebook account:", error);
      setAlert(error.message || "Failed to save Facebook account", "error");
    }
  };

  const handleFacebookLogin = async () => {
    setLoading(true);
    try {
      // @ts-ignore
      window.FB.login(
        function (response: any) {
          if (response.authResponse) {
            saveFacebookAccount(response.authResponse);
          } else {
            setAlert("Login was cancelled or not fully authorized", "warning");
          }
          setLoading(false);
        },
        {
          scope:
            "instagram_basic,instagram_manage_insights,pages_show_list,pages_read_engagement,instagram_manage_messages,pages_manage_metadata,instagram_manage_comments,pages_messaging",
        },
      );
    } catch (error) {
      setAlert("Failed to initiate Facebook login", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!currentAdminUser) {
    return <Loading />;
  }

  return (
    <StyledPage
      content={
        <>
          <Backdrop sx={styles.backdrop} open={loading}>
            <CircularProgress />
          </Backdrop>

          <Grid container sx={{ mt: 2 }} spacing={1} alignItems="center">
            <Grid item xs="auto">
              <Typography variant="h3" gutterBottom>
                <strong>Instagram Integration</strong>
              </Typography>
            </Grid>
          </Grid>

          <Card sx={styles.card}>
            <CardContent sx={styles.cardContent}>
              <Typography variant="h5" component="h2" gutterBottom>
                Facebook Account Connection
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={styles.description}
              >
                Connect your Facebook account to manage Instagram integrations
                and access Instagram Business API features for automated mention
                responses.
              </Typography>

              <LoadingButton
                variant="contained"
                size="large"
                onClick={handleFacebookLogin}
                loading={loading}
              >
                Login with Facebook
              </LoadingButton>
            </CardContent>
          </Card>

          <Alert
            message={message}
            severity={severity}
            closeAlert={closeAlert}
          />
        </>
      }
    />
  );
};

export default InstagramPage;
